module.exports = __webpack_public_path__ + "img/bom-list_normal.f1ebc544.svg";